<div class="as-pill" [class.as-visible]="visible()">
  @if (showFavourite()) {
    <button type="button" class="as-btn" [class.active]="isFavourite()" [title]="'viewer.space_detail_panel.sections.action_shelf.favourite' | transloco"
          [attr.aria-label]="'viewer.space_detail_panel.sections.action_shelf.favourite' | transloco" [attr.aria-pressed]="isFavourite()" (click)="favourite.emit()">
      <paper-icon name="heart" [size]="18"
        [fill]="isFavourite() ? 'currentColor' : undefined"
        [state]="isFavourite() ? 'active' : 'idle'"
        [interactive]="true" />
    </button>
  }
  <button type="button" class="as-btn" [title]="'viewer.space_detail_panel.sections.action_shelf.share' | transloco"
          [attr.aria-label]="'viewer.space_detail_panel.sections.action_shelf.share' | transloco" (click)="share.emit()">
    <paper-icon name="share" [size]="18" [interactive]="true" />
  </button>
  @if (showCancel()) {
    <button type="button" class="as-btn as-btn--danger" [title]="'viewer.space_detail_panel.sections.action_shelf.cancel_meeting' | transloco"
          [attr.aria-label]="'viewer.space_detail_panel.sections.action_shelf.cancel_meeting' | transloco" (click)="cancel.emit()">
      <paper-icon name="trash" [size]="18" [interactive]="true" />
    </button>
  }
</div>
